import { Dialog } from '@mui/material';
import { FunctionComponent } from 'react';

import { FooterButton } from '../FooterButtons/styled';
import { 
    dialogPaperProps, 
    DialogTitle,
    QuestReviewDialogButtonContainer,
    QuestReviewDialogContent, 
    QuestReviewDialogDescription, 
    QuestReviewTextField } from './styled';

interface QuestReviewDialogProps {
    open: boolean;
    questReviewFeedback: string;
    onQuestReviewFeedbackChange: (feedback: string) => void;
    onSubmit: (solveByReviewer: boolean) => void;
}

const QuestReviewDialog: FunctionComponent<QuestReviewDialogProps> = ({
    open,
    questReviewFeedback,
    onQuestReviewFeedbackChange,
    onSubmit
}) => {
    const handleSubmit = (solveByReviewer: boolean) => {
        onSubmit(solveByReviewer);
    };
    
    // Prevent dialog from closing - user must complete the action
    const handleClose = () => {
        // Intentionally empty - dialog should not close on backdrop click
    };

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            disableEscapeKeyDown // Prevent closing on ESC key
            aria-labelledby="quest-review-dialog-title"
            aria-describedby="quest-review-dialog-description"
            PaperProps={dialogPaperProps}
            maxWidth="md"
            fullWidth
        >
            <DialogTitle id="quest-review-dialog-title">Request Modifications</DialogTitle>
            <QuestReviewDialogContent>
                <QuestReviewDialogDescription>
                    Please describe what modifications are needed for this quest.
                    Then, you can either solve the quest by yourself or send it back for a new breakdown.
                </QuestReviewDialogDescription>
                <QuestReviewTextField
                    multiline
                    rows={6}
                    variant="outlined"
                    fullWidth
                    placeholder="Please describe what modifications are needed for this quest..."
                    value={questReviewFeedback}
                    onChange={(e) => onQuestReviewFeedbackChange(e.target.value)}
                />
                <QuestReviewDialogButtonContainer>
                    <FooterButton 
                        onClick={() => handleSubmit(false)}
                        disabled={!questReviewFeedback.trim()}
                    >
                        Back to breakdown
                    </FooterButton>
                    <FooterButton 
                        onClick={() => handleSubmit(true)}
                        disabled={!questReviewFeedback.trim()}
                    >
                        Fix by yourself
                    </FooterButton>
                </QuestReviewDialogButtonContainer>
            </QuestReviewDialogContent>
        </Dialog>
    );
};

export default QuestReviewDialog;
